import { api } from './api'
import { PatientReminder, PatientReminderFormData, ReminderRule, ReminderRuleFormData } from '../types/patientReminder'

export const patientReminderService = {
  /**
   * Get all patient reminders (optionally filtered by patient)
   */
  getAll: async (patientId?: string): Promise<PatientReminder[]> => {
    const url = patientId ? `/patient-reminders?patientId=${patientId}` : '/patient-reminders'
    const response = await api.get<PatientReminder[]>(url)
    return response.data
  },

  /**
   * Get a single reminder by ID
   */
  getById: async (id: string): Promise<PatientReminder> => {
    const response = await api.get<PatientReminder>(`/patient-reminders/${id}`)
    return response.data
  },

  /**
   * Create a new patient reminder
   */
  create: async (data: PatientReminderFormData): Promise<PatientReminder> => {
    const response = await api.post<PatientReminder>(`/patients/${data.patientId}/reminders`, data)
    return response.data
  },

  /**
   * Update an existing patient reminder
   */
  update: async (id: string, data: Partial<PatientReminderFormData>): Promise<PatientReminder> => {
    const response = await api.put<PatientReminder>(`/patient-reminders/${id}`, data)
    return response.data
  },

  /**
   * Delete a patient reminder
   */
  delete: async (id: string): Promise<void> => {
    await api.delete(`/patient-reminders/${id}`)
  },

  /**
   * Get all reminder rules
   */
  getReminderRules: async (): Promise<ReminderRule[]> => {
    const response = await api.get<ReminderRule[]>('/reminder-rules')
    return response.data
  },

  /**
   * Create a reminder rule
   */
  createRule: async (data: ReminderRuleFormData): Promise<ReminderRule> => {
    const response = await api.post<ReminderRule>('/reminder-rules', data)
    return response.data
  },

  /**
   * Get patient reminders
   */
  getPatientReminders: async (patientId: string): Promise<PatientReminder[]> => {
    const response = await api.get<PatientReminder[]>(`/patients/${patientId}/reminders`)
    return response.data
  },

  /**
   * Get delivery status for a reminder
   */
  getDeliveryStatus: async (reminderId: string): Promise<PatientReminder['deliveryDetails']> => {
    const response = await api.get<PatientReminder['deliveryDetails']>(`/patient-reminders/${reminderId}/delivery-status`)
    return response.data
  },
}
